import axiosInstance from './axiosInstance';

const paymentApi = {
    initiatePayment: (email, paymentAmount, orderId, paymentType, planKey, autoPayEnabled) =>
        axiosInstance.post('/robo_initpayment', { email, amount: paymentAmount, orderId, paymentType, planKey, autoPayEnabled }),
};

export default paymentApi;